// extracted by mini-css-extract-plugin
export default {"organizersImage":"Organizers_organizersImage__M-ZmC","organizers":"Organizers_organizers__zZlRm"};